import { useEffect, useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { useBoundStore } from 'store';
import { cacheKeys } from 'config';

export const useReviewModeRefresh = (slug: string | undefined) => {
  const queryClient = useQueryClient();
  const { reviewMode, reviewModeData } = useBoundStore((state) => ({
    reviewMode: state.reviewMode,
    reviewModeData: state.reviewModeData,
  }));

  const refreshReviewModeData = useCallback(async () => {
    if (!slug || !reviewMode) return;

    console.log('Refreshing review mode data...');

    await Promise.all([
      queryClient.invalidateQueries([cacheKeys.documents.getDocument, { slug }, false]),
      queryClient.invalidateQueries([cacheKeys.documents.getDraftDocument, { slug }, true]),
      queryClient.invalidateQueries([cacheKeys.documents.getDocument, { slug }, true, 'version']),
      queryClient.invalidateQueries([cacheKeys.documents.getDocument, { slug }, false, 'version']),
      queryClient.invalidateQueries(cacheKeys.documents.compareVersions),
      queryClient.invalidateQueries(cacheKeys.documents.getDocumentHistoryV2),
    ]);

    useBoundStore.setState((state) => ({
      reviewModeData: {
        ...state.reviewModeData,
        needsRefresh: false,
      },
    }));
  }, [slug, reviewMode, queryClient]);

  useEffect(() => {
    if (reviewMode && reviewModeData.needsRefresh) {
      refreshReviewModeData();
    }
  }, [reviewMode, reviewModeData.needsRefresh, refreshReviewModeData]);

  return { refreshReviewModeData };
};